import LazyLoadImage from "apps/teacher/components/common/LazyLoadImage";
import React, { useRef, useState } from "react";
import DownloadButton from './downloadButton.svg';
import DownloadIcon from './downloadIcon.svg';
import IconBookmarkedList from './IconBookMarkHollow.svg';
import IconBookmark from './IconBookMark.svg';
import './style.scss';
import { usePrintableWorksheetsState } from "printableWorksheets/state";
import { WorksheetsEnvironment } from "printableWorksheets";
import PrintableWorksheetsEvents from "printableWorksheets/events";
import * as PrintableWorksheetsApi from '../../../api'
import Button, { ButtonTypes } from "printableWorksheets/atoms/Button";
import PDFViewer from "../../../../teacherDashboard/teacher/components/common/PDFViewer";
import useIsInViewport from "hooks/useIsInViewport";
import WSPreview from "../wsPreview";
import WSLimitReachedPopup from "../wsLimitReached";
import { canDownloadWs } from "apps/teacher/config/common";
import { useAppMediaProvider } from '../../../../baseStyles/AppMediaProvider';

declare let window: any;

const WorksheetCard = ({card, isLastCard} : {card: any; isLastCard?: boolean}) => {
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [showWorksheetPreview, setShowWorksheetPreview] = useState(false);
    const [showLimitReachedPopup, setShowLimitReachedPopup] = useState(false);

    const {activeGrade, userId, worksheetsEnvironment, savedWorksheets, downloadedWorksheets, setDownloadedWorksheets, setSavedWorksheets, setSavedCount, setDownloadCount} = usePrintableWorksheetsState();

    const { isDesktop } = useAppMediaProvider();

    const deepCopyObject = (obj: any) => {
        return JSON.parse(JSON.stringify(obj));
    }

    const worksheetCardRef = useRef();

    useIsInViewport(() => {
        if(isLastCard){
            PrintableWorksheetsEvents.viewedWorksheetSearchResultsEndPage();
        }
    }, worksheetCardRef);

    const onSave = (worksheetDetails: any) => {
        PrintableWorksheetsEvents.interactedWorksheetListingPage({
            clickedOn: "Saved Worksheet"
        })
        if (worksheetDetails.id && userId) {
            PrintableWorksheetsApi.postUserSavedCollection({
                userId,
                params: {
                    entity_id: worksheetDetails.id,
                    entity_type: 'SearchContent'
                },
            }).then((result: any = {}) => {
                savedWorksheets[worksheetDetails?.id] = result.user_collection_entity || {};
                setSavedWorksheets(deepCopyObject(savedWorksheets));
                setSavedCount((savedCount: number) => savedCount + 1);
                showFlashMessage('Worksheet saved successfully', 'success');
                window.dispatchEvent(new CustomEvent('saved-worksheets-update'));
                PrintableWorksheetsEvents.savedWorksheet({
                    worksheetGrade: activeGrade,
                    worksheetCategory: "",
                    worksheetSubcategory: "",
                    from: selectedPdf ? "Preview" : "Worksheet Listing Page"
                })
            })
        }
    };

    const previewWorksheet = (card: any) => {
        PrintableWorksheetsEvents.interactedWorksheetListingPage({
            clickedOn: "Preview Clicked"
        })
        PrintableWorksheetsEvents.previewedWorksheet({
            worksheetName: card.title,
            worksheetGrade: activeGrade,
            worksheetCategory: "",
            worksheetSubcategory: "",
        })
        setSelectedPdf(card)
    }

    const onUnSave = (entity_id: any) => {
        PrintableWorksheetsEvents.interactedWorksheetListingPage({
            clickedOn: "UnSave Clicked"
        })
        if (entity_id && userId) {
            PrintableWorksheetsApi.deleteUserCollection({
                userId,
                id: savedWorksheets[entity_id]?.id,
            }).then((result: any = {}) => {
                delete savedWorksheets[entity_id];
                setSavedWorksheets(deepCopyObject(savedWorksheets || {}));
                setSavedCount((savedCount: number) => savedCount - 1);
                showFlashMessage('Worksheet unsaved successfully', 'success');
                window.dispatchEvent(new CustomEvent('saved-worksheets-update'));
            })
        }
    };


    const onDownload = () => {
        PrintableWorksheetsEvents.interactedWorksheetListingPage({
            clickedOn: "Download Worksheet"
        })
        if (card.id && userId) {
          // GlobalSpinner.show();
          fetch(card.pdf_url, {
              credentials: 'omit'
          }).then((res) => res.blob()).then((blob) => {
              // GlobalSpinner.hide();
              const a = document.createElement("a");
              a.href = window.URL.createObjectURL(blob);
              a.download = card.title;
              a.target = '_system';
              a.click();
              a.remove();
              if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
                PrintableWorksheetsApi.postSaveUserDownload({
                    userId,
                      params: {
                          entity_id: card.id,
                          entity_type: 'SearchContent'
                      },
                      callback: () => {
                        showFlashMessage('Worksheet downloaded successfully', 'success');
                        if(!downloadedWorksheets.find((ws: any) => ws.id === card.id)){
                            setDownloadedWorksheets((dws: any) => [...dws, card]);
                            setDownloadCount((downloadCount: number) => downloadCount + 1);
                        }
                        window?.dispatchEvent(new CustomEvent('download-worksheets-update'));
                        const props = {
                            worksheetName: card.title,
                            worksheetGrade: activeGrade.toLowerCase(),
                            worksheetCategory: "",
                            worksheetSubcategory: "",
                            from: "Worksheet Listing Page"
                        }
                        PrintableWorksheetsEvents.downloadedWorksheet(props);
                      }
                  })
              }
          }).catch((e)=> {
            // sendErrorToSentry(new Error("Worksheet download failed"), card)
        })
        }
      };
    
    const onWorksheetCardClick = () => {
        if(isDesktop) {
            if(canDownloadWs()) {
                setShowWorksheetPreview(true);
            }
            else {
                setShowLimitReachedPopup(true);
            }
            if(window.parent.triggerIsFlutterHeaderClickDisabled) {
                window.parent.triggerIsFlutterHeaderClickDisabled();
            }
        }
        else {
            window.open(card?.pdf_url);
            PrintableWorksheetsEvents.downloadedWorksheetB2c({
                worksheetName: card.title,
                worksheetCode: card.code
            });
        }
    }

    return (
        <>
            {showWorksheetPreview &&
                <WSPreview worksheetDetails={card} setShowWorksheetPreview={setShowWorksheetPreview} showWorksheetPreview={showWorksheetPreview} />
            }
            {showLimitReachedPopup ?
                <WSLimitReachedPopup worksheetDetails={card} setShowLimitReachedPopup={setShowLimitReachedPopup} />
        :
    <div 
        className={`worksheet-card ${worksheetsEnvironment}`} 
        ref={worksheetCardRef}
        onClick={() => {
            if(worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD) {
                PrintableWorksheetsEvents.interactedWorksheetListingPage({
                    clickedOn: "Worksheet Card"
                });
                onWorksheetCardClick();    
            }
        }}
    >
        <div className="img-container" onClick={()=> {
                worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD && previewWorksheet(card);
            }}>
                <div className="bg-img-container">
                    {   worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ?
                        <LazyLoadImage src={card.image_url} alt="worksheetImage" /> : <img src={card.image_url} alt="worksheetImage"/>
                    }
                    { worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ?
                    <div className="preview" onClick={() => previewWorksheet(card)}>
                        <button>Preview</button>
                    </div> : null
                    }
                </div>
            <div className="actions">
                {worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD ? <a className="download-button" ><DownloadButton /></a> : null}
            </div>
        </div>
        <div className="info-container">
            <div className="details">
                {/* <div className="topic">{card.topic_name}</div> */}
                {worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? (
                    <>
                        <div className="title" title={card.title}>{card.title}</div>
                        <div className="meta_description">{card.description}</div>
                        <div className="cta-container">
                            <Button
                                type={ButtonTypes.primary}
                                onClick={onDownload}
                                className='custom-download-btn'
                            >
                                <div className="icn-container">
                                    <DownloadIcon />
                                </div>
                                Download
                            </Button>
                            <a onClick={() => savedWorksheets[card.id] ? onUnSave(card.id) : onSave(card)} className={`bookmark-button ${savedWorksheets[card.id] ? 'active' : ''}`}>{!savedWorksheets[card.id] ? <><IconBookmarkedList /> <label>Saved</label></> : <><IconBookmark /> <label>Save</label></>} </a>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="meta_description st-ws">{card.title}</div>
                        {/* <div className="title st-ws" title={card.title}>{card.description}</div> */}
                    </>
                )}
            </div>
        </div>
        {
            selectedPdf && selectedPdf.pdf_url &&
            <PDFViewer
                title={selectedPdf?.title}
                subtitle={selectedPdf?.meta_description}
                file={selectedPdf?.pdf_url}
                onBack={() => setSelectedPdf(null)}
                onSave={() => onSave(selectedPdf)}
                onUnsave={() => onUnSave(selectedPdf?.id)}
                onDownload={() => onDownload()}
                isSaved={savedWorksheets[selectedPdf?.id]}
            />
        }
    </div>
    }
    </>)
}
export {WorksheetCard}